import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    developer: {
        detail: {},
        isLoading: true
    },
    tech: {
        isTechLoading: true,
        technologies: [],
    },
    spec: {
        isLoading: true,
        specializationList: []
    },
    hire_registration: {
        step: 1,
        stepOneData: {
            specialization: null,
        },
        stepTwoData: {
            skills: []
        },
        stepThreeData: {

        },
    },
    selected_skill: null,
    showSuccessModal: false
};

export const commonSlice = createSlice({
    name: "common",
    initialState,
    reducers: {
        setDeveloperDetail: (state, { payload }) => {
            state.developer.detail = payload;
        },
        setDeveloperLoading: (state, { payload }) => {
            state.developer.isLoading = payload;
        },
        setTechnologies: (state, { payload }) => {
            state.tech.technologies = payload;
        },
        setTechnologyLoading: (state, { payload }) => {
            state.tech.isTechLoading = payload;
        },
        setSpecializationList: (state, { payload }) => {
            state.spec.specializationList = payload;
        },
        setSpecializationLoading: (state, { payload }) => {
            state.spec.isLoading = payload;
        },
        hireRegistrationNextStep: (state) => {
            const { step } = state.hire_registration
            state.hire_registration.step = step + 1
        },
        hireRegistrationPrevStep: (state) => {
            const { step } = state.hire_registration
            state.hire_registration.step = step - 1
        },
        setHireRegistrationFormData: (state, { payload }) => {
            const { step } = state.hire_registration;
            const { formData } = payload;
            return {
                ...state,
                hire_registration: {
                    ...state.hire_registration,
                    ...(step === 1 && { stepOneData: { ...state.hire_registration.stepOneData, ...formData } }),
                    ...(step === 2 && { stepTwoData: { ...state.hire_registration.stepTwoData, ...formData } }),
                    ...(step === 3 && { stepThreeData: { ...state.hire_registration.stepThreeData, ...formData } }),
                }
            }
        },
        setShowSuccessModal: (state, { payload }) => {
            state.showSuccessModal = payload;
        },
        setSelectedSkill: (state, { payload }) => {
            state.selected_skill = payload;
        }
    },
});

export const {
    setTechnologies,
    setTechnologyLoading,
    setDeveloperDetail,
    setDeveloperLoading,
    setSpecializationList,
    setSpecializationLoading,
    hireRegistrationNextStep,
    hireRegistrationPrevStep,
    setHireRegistrationFormData,
    setShowSuccessModal,
    setSelectedSkill
} = commonSlice.actions;
export default commonSlice.reducer;